export default __webpack_public_path__ + "static/media/4524.41fc23a0.png";